import { watch, type Ref, type WatchSource } from "vue";

export function useAppDeselectOnChange<T>(selected: Ref<T | undefined>, sources: WatchSource | WatchSource[]): void {
  watch(Array.isArray(sources) ? sources : [sources], () => {
    if (selected.value !== undefined) selected.value = undefined;
  });
}
